import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { InsuranceService } from '../../../../../../services/insurance.service';
import { MenuItem } from 'primeng/api';

import { Claim } from '../../../models/claim.models';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { HelpersService } from '../../../../../../services/helpers.service';

import moment from 'moment';

interface ConfiguredTask {
  ID: number;
  Name: string;
}

@Component({
  selector: 'app-single-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss', '../../../css/_shared.scss'],
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None,
})
export class ClaimComponent implements OnInit {
  @Input() claimID;

  currentStatusID = 0;

  selectedNavigationItem: any;

  public navigationItems: any = [];
  public statuses: SelectItem[] = [];
  public selectedStatus: any;
  public columns: any = [];
  public claims: any = [];
  public showClaim: boolean = false;
  public tabMenuItems: any[] = [];
  public selectedTabMenuItem: any;

  public activeItem: MenuItem;
  claimObject: Claim;

  bikes: string[] = [];
  components: string[] = [];
  bikeSelectList: SelectItem[] = [];

  public showTasks: boolean = true;
  public showClaims: boolean = false;
  public showAttachments: boolean = false;
  public showQuotes: boolean = false;
  public showMessages: boolean = false;
  public showProcurement: boolean = false;

  excess: number = 0;
  sumInsured: number = 0;

  incidentTypes: SelectItem[];
  selectedIncidentType: any;

  mapOptions: any;
  overlays: any[];

  public blockStatus: boolean = false;
  public documentLink: string = '';

  public showConfirmation: boolean = false;

  //====================================================================================
  //TASKS
  //====================================================================================

  public employees: SelectItem[] = [];
  public selectedEmployee: any;
  public selectedTaskEmployee: any;

  public errorNotUnassigned: boolean = false;
  public errorNotYours: boolean = false;

  public errorNotUnassignedT: boolean = false;
  public errorNotYoursT: boolean = false;

  configuredTasks: SelectItem[];
  selectedConfiguredTasks: ConfiguredTask;

  public dueDate: Date;
  public note: string = '';
  public allNotes: any[] = [];

  //====================================================================================
  //QUOTES
  //====================================================================================

  public bikeSelected: any;
  public message: string = '';
  public sending: boolean = false;
  quoteObject: any = {};
  partners: SelectItem[] = [];
  selectedPartner: any;
  public messages: any[] = [];
  lineItems: any[] = [];
  public subtotal: number = 0.0;
  public tax: number = 0.0;
  public total: number = 0.0;

  //====================================================================================
  //MESSAGING
  //====================================================================================
  public notifications: any = [];
  public sendingM = false;
  public messageM: string = '';
  public messageMSMS: number = 0;

  //====================================================================================
  //MESSAGING
  //====================================================================================
  documents: any[] = [];
  images: any[] = [];
  uploadedFiles: any[] = [];

  constructor(
    public insuranceService: InsuranceService,
    public helpersService: HelpersService,
  ) {}

  ngOnChanges(changes) {
    //console.log(changes);
    //console.log(changes.claimID.currentValue);
    this.claimID = changes.claimID.currentValue;

    if (this.claimID > 0) {
      this.displayClaim(this.claimID);
      this.selectedTabMenuItem = this.tabMenuItems[0];
      this.showTasks = true;
      this.showClaims = false;
      this.showAttachments = false;
      this.showQuotes = false;
      this.showMessages = false;
      this.showProcurement = false;
    }
  }

  ckeckStatusLock() {
    if (sessionStorage.getItem('BlockStatus') == 'true')
      this.blockStatus = true;
    else this.blockStatus = false;
  }

  getSMSCount() {
    this.messageMSMS = Math.ceil(this.messageM.length / 160);
  }

  ngOnInit() {
    setInterval(() => {
      this.ckeckStatusLock();
    }, 1000);
    setInterval(() => {
      this.getMessages();
    }, 10000);

    sessionStorage.setItem('BlockStatus', 'false');

    this.claimObject = new Claim(
      0,
      0,
      '',
      '',
      0,
      '',
      0,
      '',
      0,
      0,
      '',
      0,
      0,
      new Date(),
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      [],
      [],
      '',
      '',
      '',
    );

    this.insuranceService.getClaimsStatus().subscribe((response) => {
      var obj = JSON.parse(response);

      for (var i = 0; i < obj.ClaimStatus.length; i++) {
        this.navigationItems.push({
          ID: obj.ClaimStatus[i].ID,
          title: obj.ClaimStatus[i].Description,
          backgroundImage: obj.ClaimStatus[i].Icon,
        });
        this.statuses.push({
          label: obj.ClaimStatus[i].Description,
          value: {
            ID: obj.ClaimStatus[i].ID,
            title: obj.ClaimStatus[i].Description,
            backgroundImage: obj.ClaimStatus[i].Icon,
            StatusOrder: obj.ClaimStatus[i].StatusOrder,
          },
        });
      }

      this.selectedNavigationItem = this.navigationItems[0];
      this.currentStatusID = this.selectedNavigationItem.ID;
    });

    this.configuredTasks = [
      { label: 'Select pre-typed task or type your own', value: null },
    ];

    this.insuranceService.getConfiguredNotes().subscribe((response) => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.ClaimTasks.length; i++) {
        this.configuredTasks.push({
          label: obj.ClaimTasks[i].Description,
          value: { ID: obj.ClaimTasks[i].ID },
        });
      }
    });

    this.columns = [
      { header: 'Claim', field: 'ClaimNumber', type: 'string' },
      { header: 'Insurer', field: 'Insurer', type: 'string' },
      { header: 'Customer', field: 'InsuredName', type: 'string' },
      { header: 'Age', field: 'Age', type: 'string' },
      { header: 'Status', field: 'Status', type: 'string' },
      { header: 'Due date', field: 'DueDate', type: 'string' },
      { header: 'Assessor', field: 'AssigneeName', type: 'string' },
      { header: '', field: 'ID', type: 'action' },
    ];

    this.incidentTypes = [
      { label: 'Select Incident Type', value: null },
      { label: 'Accidental damage', value: { label: 'Accidental damage' } },
      { label: 'Theft from home', value: { label: 'Theft from home' } },
      {
        label: 'Theft away from home',
        value: { label: 'Theft away from home' },
      },
    ];

    this.tabMenuItems = [
      {
        ID: 1,
        title: 'Tasks/Notes',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/64-512.png',
      },
      {
        ID: 2,
        title: 'Claim form',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/64-512.png',
      },
      {
        ID: 3,
        title: 'Attachments',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/62-512.png',
      },
      {
        ID: 4,
        title: 'Quotes',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/20-512.png',
      },
      {
        ID: 6,
        title: 'Search',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/38-512.png',
      },
      {
        ID: 5,
        title: 'Client Messaging',
        backgroundImage:
          'https://cdn3.iconfinder.com/data/icons/contact-us-set-1/256/38-512.png',
      },
    ];

    //====================================================================================
    //TASKS
    //====================================================================================
    this.employees = [];
    this.employees.push({
      label: 'Not Assigned',
      value: { ID: 0, Name: 'Not Assigned', Role: 'RAW Admin' },
    });
    this.insuranceService.getPossibleAssignees().subscribe((response) => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Employees.length; i++) {
        this.employees.push({
          label: obj.Employees[i].Name,
          value: obj.Employees[i],
        });
      }
    });
    this.loadTasks();

    //====================================================================================
    //QUOTES
    //====================================================================================
    this.messages = [];
    this.message = '';

    this.insuranceService.getPartners().subscribe((response) => {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Partners.length; i++) {
        this.partners.push({
          label: obj.Partners[i].Name,
          value: obj.Partners[i],
        });
      }
    });

    if (this.claimObject.Quotes == undefined) this.claimObject.Quotes = {};

    //====================================================================================
    //MESSAGING
    //====================================================================================
    this.displayClaim(this.claimObject.ID);

    if (this.claimObject.Messages == undefined) {
      this.claimObject.Messages = [];
    }

    if (this.claimObject.Messages.length == 1) {
      if (this.claimObject.Messages[0].To == undefined) {
        this.claimObject.Messages = [];
      }
    }

    //====================================================================================
    //ATTACHMENTS
    //====================================================================================
    this.images = [];
    this.documents = [];
    if (this.claimObject.ID !== 0) {
      this.claimID = this.claimObject.ID;
      this.loadDocuments();
      this.loadImages();
    }
  }

  openGoBackInStatus() {
    this.blockStatus = false;
    sessionStorage.setItem('BlockStatus', 'false');

    //console.log(this.navigationItems);

    //this.insuranceService.getClaimsStatus().subscribe(response => {
    //  var obj = JSON.parse(response);

    //  for (var i = 0; i < obj.ClaimStatus.length; i++) {
    //    this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });
    //  }

    //  //var orderNo = 0;
    //  //for (var i = 0; i < this.statuses.length; i++) {
    //  //  if (this.statuses[i].value.ID == this.claimObject.StatusID)
    //  //    orderNo = this.statuses[i].value.StatusOrder;
    //  //}

    //  //this.statuses = [];
    //  //for (var i = 0; i < obj.ClaimStatus.length; i++) {
    //  //  if (obj.ClaimStatus[i].StatusOrder <= orderNo)
    //  //    this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });

    //  //  if (obj.ClaimStatus[i].StatusOrder == orderNo)
    //  //    this.selectedStatus = this.navigationItems[i];
    //  //  //this.currentStatusID = obj.ClaimStatus[i].ID;
    //  //}

    //  //for (var i = 0; i < this.navigationItems.length; i++) {
    //  //  if (this.navigationItems[i].title == this.claimObject.Status) {
    //  //    this.selectedStatus = this.navigationItems[i];
    //  //  }
    //  //}

    //});
  }

  public getClaims(statusID) {
    (this.currentStatusID = statusID), (this.claims = []);

    this.insuranceService.getClaims(statusID).subscribe((response) => {
      if (response !== '') {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Claims.length; i++) {
          this.claims.push(obj.Claims[i]);
        }
      }
    });
  }

  public displayClaim(claimID) {
    this.showConfirmation = false;
    this.showClaim = true;
    try {
      this.insuranceService.getClaim(claimID).subscribe((response) => {
        this.claimObject = new Claim(
          0,
          0,
          '',
          '',
          0,
          '',
          0,
          '',
          0,
          0,
          '',
          0,
          0,
          new Date(),
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          [],
          [],
          '',
          '',
        );
        this.bikes = [];
        this.bikeSelectList = [];
        this.allNotes = [];
        this.components = [];
        this.setClaimObj(response);
      });
    } catch (e) {}
  }

  minimizeAndSaveClaim() {
    this.showClaim = false;
    let element: HTMLElement = document.getElementsByClassName(
      'p-sidebar-close',
    )[0] as HTMLElement;
    element.click();

    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    for (var i = 0; i < this.allNotes.length; i++) {
      this.claimObject.Notes.push({
        ID: this.allNotes[i].ID,
        ClaimID: this.allNotes[i].ClaimID,
        DueDate: this.allNotes[i].DueDate,
        Description: this.allNotes[i].Description,
        Completed: this.allNotes[i].Completed,
        Assignee: this.allNotes[i].Assignee,
        AssigneeID: this.allNotes[i].AssigneeID,
        IsStandardTask: this.allNotes[i].IsStandardTask,
      });
    }

    this.saveClaim();
  }

  minimizeAndDeleteClaim() {
    this.showClaim = false;
    let element: HTMLElement = document.getElementsByClassName(
      'p-sidebar-close',
    )[0] as HTMLElement;
    element.click();

    this.claimObject.StatusID = 7;
    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    for (var i = 0; i < this.allNotes.length; i++) {
      this.claimObject.Notes.push({
        ID: this.allNotes[i].ID,
        ClaimID: this.allNotes[i].ClaimID,
        DueDate: this.allNotes[i].DueDate,
        Description: this.allNotes[i].Description,
        Completed: this.allNotes[i].Completed,
        Assignee: this.allNotes[i].Assignee,
        AssigneeID: this.allNotes[i].AssigneeID,
        IsStandardTask: this.allNotes[i].IsStandardTask,
      });
    }

    this.saveClaim();
  }

  dontMinimizeAndSaveClaim() {
    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    if (this.claimObject.Notes == undefined) this.claimObject.Notes = [];

    for (var i = 0; i < this.allNotes.length; i++) {
      this.claimObject.Notes.push({
        ID: this.allNotes[i].ID,
        ClaimID: this.allNotes[i].ClaimID,
        DueDate: this.allNotes[i].DueDate,
        Description: this.allNotes[i].Description,
        Completed: this.allNotes[i].Completed,
        Assignee: this.allNotes[i].Assignee,
        AssigneeID: this.allNotes[i].AssigneeID,
        IsStandardTask: this.allNotes[i].IsStandardTask,
      });
    }

    this.saveClaim();
  }

  saveClaim() {
    if (this.claimObject.IncidentDetails == undefined)
      this.claimObject.IncidentDetails = '';
    if (this.claimObject.IncidentLocation == undefined)
      this.claimObject.IncidentLocation = '';

    let re = /'/gi;
    this.claimObject.IncidentDetails = this.claimObject.IncidentDetails.replace(
      re,
      '`',
    );
    this.claimObject.IncidentLocation =
      this.claimObject.IncidentLocation.replace(re, '`');

    for (var i = 0; i < this.claimObject.Notes.length; i++) {
      if (this.claimObject.Notes[i].Description !== undefined)
        this.claimObject.Notes[i].Description = this.claimObject.Notes[
          i
        ].Description.replace(re, '`');
    }

    if (this.claimObject.Insurer == '') return;

    var count = 0;
    var arrC = 0;

    this.insuranceService.saveClaim(this.claimObject).subscribe((response) => {
      this.displayClaim(this.claimObject.ID);

      this.getClaims(this.currentStatusID);
    });
  }

  setClaimObj(response) {
    this.bikes = [];
    this.bikeSelectList = [];
    this.allNotes = [];
    this.components = [];

    if (response !== '') {
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Claims.length; i++) {
        this.claimObject = obj.Claims[i];
      }

      this.statuses = [];
      this.insuranceService.getClaimsStatus().subscribe((response) => {
        //this.statuses = [];
        //if (this.claimObject.StatusID == 7) {
        //  var obj = JSON.parse(response);
        //  for (var i = 0; i < obj.ClaimStatus.length; i++) {
        //    this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });
        //  }
        //}
        //else {
        //  if (this.claimObject.StatusID == 4) {
        //    var obj = JSON.parse(response);
        //    var pos = -5;
        //    for (var i = 0; i < obj.ClaimStatus.length; i++) {
        //      if (this.claimObject.StatusID == obj.ClaimStatus[i].ID) {
        //        this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });
        //        pos = obj.ClaimStatus[i].StatusOrder;
        //      }
        //      if (i > pos && pos !== -5)
        //        this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });
        //    }
        //  }
        //  else {
        //    var obj = JSON.parse(response);
        //    var pos = -5;
        //    for (var i = 0; i < obj.ClaimStatus.length; i++) {
        //      if (this.claimObject.StatusID == obj.ClaimStatus[i].ID) {
        //        this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });
        //        pos = obj.ClaimStatus[i].StatusOrder;
        //      }
        //      if (pos + 1 == obj.ClaimStatus[i].StatusOrder)
        //        this.statuses.push({ label: obj.ClaimStatus[i].Description, value: { ID: obj.ClaimStatus[i].ID, title: obj.ClaimStatus[i].Description, backgroundImage: obj.ClaimStatus[i].Icon, StatusOrder: obj.ClaimStatus[i].StatusOrder } });

        //    }
        //  }
        //}

        this.selectedNavigationItem = this.navigationItems[0];
        this.currentStatusID = this.selectedNavigationItem.ID;
      });

      if (this.claimObject.Bikes != undefined) {
        for (var i = 0; i < this.claimObject.Bikes.length; i++) {
          this.bikes.push(this.claimObject.Bikes[i].Name);
          this.bikeSelectList.push({
            label: this.claimObject.Bikes[i].Name,
            value: this.claimObject.Bikes[i].Name,
          });
        }
      }

      for (var i = 0; i < this.claimObject.Notes.length; i++) {
        this.allNotes.push(this.claimObject.Notes[i]);
      }

      for (var i = 0; i < this.allNotes.length; i++) {
        if (this.allNotes[i].Completed === false)
          this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
      }

      this.blockStatus = false;
      for (var i = 0; i < this.allNotes.length; i++) {
        if (
          this.allNotes[i].Completed === false &&
          this.allNotes[i].IsStandardTask === true
        )
          this.blockStatus = true;
      }

      this.statuses = [];
      for (var i = 0; i < this.navigationItems.length; i++) {
        if (this.navigationItems[i].title == this.claimObject.Status) {
          this.selectedStatus = this.navigationItems[i];
        }
      }
      for (var i = 0; i < this.navigationItems.length; i++) {
        this.statuses.push({
          label: this.navigationItems[i].title,
          value: {
            ID: this.navigationItems[i].ID,
            title: this.navigationItems[i].title,
            backgroundImage: this.navigationItems[i].backgroundImage,
          },
        });
      }

      for (var i = 0; i < this.incidentTypes.length; i++) {
        if (this.incidentTypes[i].label == this.claimObject.IncidentType) {
          this.incidentTypes = [
            {
              label: this.incidentTypes[i].label,
              value: { label: this.incidentTypes[i].label },
            },
            { label: 'Select New Incident Type', value: null },
            {
              label: 'Accidental damage',
              value: { label: 'Accidental damage' },
            },
            { label: 'Theft from home', value: { label: 'Theft from home' } },
            {
              label: 'Theft away from home',
              value: { label: 'Theft away from home' },
            },
          ];

          this.selectedIncidentType = this.incidentTypes[0];
        }
      }

      if (this.bikeSelectList.length > 0) {
        this.bikeSelected = this.bikeSelectList[0].value;
        this.showComponents();
      }
      this.claimObject.IncidentDate = new Date(this.claimObject.IncidentDate);

      if (response !== '') {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Claims.length; i++) {
          this.claimObject = obj.Claims[i];
        }
        this.claimObject.IncidentDate = new Date(this.claimObject.IncidentDate);

        if (this.claimObject.Messages == undefined) {
          this.claimObject.Messages = [];
        }

        if (this.claimObject.Messages.length == 1) {
          if (this.claimObject.Messages[0].To == undefined) {
            this.claimObject.Messages = [];
          }
        }
      }

      this.selectedEmployee = { ID: 0, Name: '' };
      this.selectedEmployee.ID = this.claimObject.AssigneeID;
      this.selectedEmployee.Name = this.claimObject.AssigneeName;

      this.loadTasks();
      this.loadDocuments();
      this.loadImages();
    }
  }

  showPage(id) {
    this.dontMinimizeAndSaveClaim();

    this.showTasks = false;
    this.showClaims = false;
    this.showAttachments = false;
    this.showQuotes = false;
    this.showMessages = false;
    this.showProcurement = false;

    if (id === 1) this.showTasks = true;
    if (id === 2) this.showClaims = true;
    if (id === 3) {
      this.showAttachments = true;
    }
    if (id === 4) this.showQuotes = true;
    if (id === 5) this.showMessages = true;
    if (id === 6) this.showProcurement = true;
  }

  addBike(event) {
    if (this.claimObject.Bikes == undefined) {
      this.claimObject.Bikes = [];
    }
    if (this.bikeSelectList == undefined) {
      this.bikeSelectList = [];
    }
    this.bikeSelectList.push({ label: event.value, value: event.value });
    this.claimObject.Bikes.push({
      ID: 0,
      Name: event.value,
      Components: [],
      Excess: 0,
      SumInsured: 0,
    });
  }

  addComponentToBike(event) {
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        if (this.claimObject.Bikes[i].Components == undefined)
          this.claimObject.Bikes[i].Components = [];

        this.claimObject.Bikes[i].Components.push({
          ID: 0,
          Description: event.value,
        });
      }
    }
  }

  removeBike(event) {
    for (var i = 0; i < this.bikeSelectList.length; i++) {
      if (this.bikeSelectList[i].label === event.value) {
        this.bikeSelectList.splice(i, 1);
        i--;
      }
    }

    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === event.value) {
        this.claimObject.Bikes.splice(i, 1);
        i--;
      }
    }
  }

  removeComponentToBike(event) {
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        for (var x = 0; x < this.claimObject.Bikes[i].Components.length; x++) {
          if (this.claimObject.Bikes[i].Components[x] === event.value) {
            this.claimObject.Bikes[i].Components.splice(x, 1);
            x--;
          }
        }
      }
    }
  }

  addExcessToBike() {
    console.log('Adding Excess');
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        this.claimObject.Bikes[i].Excess = this.excess;
      }
    }
  }

  addSumInsuredToBike() {
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        this.claimObject.Bikes[i].SumInsured = this.sumInsured;
      }
    }
  }

  showComponents() {
    this.components = [];
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name === this.bikeSelected.toString()) {
        if (this.claimObject.Bikes[i].Components !== undefined) {
          for (
            var x = 0;
            x < this.claimObject.Bikes[i].Components.length;
            x++
          ) {
            this.components.push(
              this.claimObject.Bikes[i].Components[x].Description,
            );
          }
        }

        this.excess = this.claimObject.Bikes[i].Excess;
        this.sumInsured = this.claimObject.Bikes[i].SumInsured;
      }
    }
  }

  setStatus() {
    this.claimObject.StatusID = this.selectedStatus.ID;
    this.claimObject.Status = this.selectedStatus.title;
    this.dontMinimizeAndSaveClaim();
  }

  setEmployee() {
    this.claimObject.AssigneeID = this.selectedEmployee.ID;
    this.claimObject.AssigneeName = this.selectedEmployee.Name;
    this.dontMinimizeAndSaveClaim();
  }

  formatMoney(number, decPlaces, decSep, thouSep) {
    (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === 'undefined' ? '.' : decSep);
    thouSep = typeof thouSep === 'undefined' ? ',' : thouSep;
    var sign = number < 0 ? '-' : '';
    var i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces))),
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;

    var obj =
      sign +
      (j ? i.substr(0, j) + thouSep : '') +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, '$1' + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - parseInt(i))
            .toFixed(decPlaces)
            .slice(2)
        : '');

    return obj;
  }

  goToUrl() {
    if (this.claimObject.DocumentLink == null) return;
    if (this.claimObject.DocumentLink == undefined) return;
    if (this.claimObject.DocumentLink == '') return;

    var win = window.open(this.claimObject.DocumentLink, '_blank');
    win.focus();
  }

  //====================================================================================
  //TASKS
  //====================================================================================

  loadTasks() {
    this.allNotes = [];
    this.insuranceService
      .getNotes(this.claimObject.ID)
      .subscribe((response) => {
        this.allNotes = [];
        if (response !== '') {
          var obj = JSON.parse(response);
          for (var i = 0; i < obj.Notes.length; i++) {
            this.allNotes.push(obj.Notes[i]);
          }
          for (var i = 0; i < this.allNotes.length; i++) {
            if (this.allNotes[i].Completed === false)
              this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
          }
          sessionStorage.setItem('BlockStatus', 'false');
          for (var i = 0; i < this.allNotes.length; i++) {
            if (
              this.allNotes[i].Completed === false &&
              this.allNotes[i].IsStandardTask == true
            )
              sessionStorage.setItem('BlockStatus', 'true');
          }
        } else {
          for (var i = 0; i < this.claimObject.Notes.length; i++) {
            this.allNotes.push(this.claimObject.Notes[i]);
          }

          for (var i = 0; i < this.allNotes.length; i++) {
            if (this.allNotes[i].Completed === false)
              this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
          }
        }
      });
  }

  saveTaskNote(obj) {
    this.insuranceService.saveNotes(obj).subscribe((response) => {
      this.allNotes = [];
      var obj = JSON.parse(response);
      for (var i = 0; i < obj.Notes.length; i++) {
        this.allNotes.push(obj.Notes[i]);
      }
      for (var i = 0; i < this.allNotes.length; i++) {
        if (this.allNotes[i].Completed === false)
          this.allNotes[i].DueDate = new Date(this.allNotes[i].DueDate);
      }
      sessionStorage.setItem('BlockStatus', 'false');
      for (var i = 0; i < this.allNotes.length; i++) {
        if (
          this.allNotes[i].Completed === false &&
          this.allNotes[i].IsStandardTask == true
        )
          sessionStorage.setItem('BlockStatus', 'true');
      }
    });
  }

  createTask() {
    if (this.note.length > 0) {
      let re = /'/gi;
      this.note = this.note.replace(re, '`');
      var date = new Date();
      var obj = {
        ID: 0,
        ClaimID: this.claimObject.ID,
        DueDate: date,
        Description: this.note,
        Completed: false,
        Assignee:
          this.helpersService.getProfileData().Name +
          ' ' +
          this.helpersService.getProfileData().Surname,
        AssigneeID: this.helpersService.getProfileData().ID,
      };
      this.allNotes.push(obj);
      this.saveTaskNote(obj);
      this.note = '';
    }
  }

  createNote() {
    if (this.note.length > 0) {
      let re = /'/gi;
      this.note = this.note.replace(re, '`');
      var date = new Date();
      var obj = {
        ID: 0,
        ClaimID: this.claimObject.ID,
        DueDate: date,
        Description: this.note,
        Completed: true,
        Assignee:
          this.helpersService.getProfileData().Name +
          ' ' +
          this.helpersService.getProfileData().Surname,
        AssigneeID: this.helpersService.getProfileData().ID,
      };
      this.allNotes.push(obj);
      this.saveTaskNote(obj);
      this.note = '';
    }
  }

  completeTask(position) {
    this.errorNotUnassignedT = false;
    this.errorNotYoursT = false;
    this.errorNotUnassigned = false;
    this.errorNotYours = false;

    for (var i = 0; i < this.allNotes.length; i++) {
      if (i == position) {
        if (this.allNotes[i].IsStandardTask == 1) {
          if (
            this.allNotes[i].Assignee != 'Not Assigned' &&
            this.allNotes[i].Assignee ==
              this.helpersService.getProfileData().Name +
                ' ' +
                this.helpersService.getProfileData().Surname
          ) {
            this.errorNotUnassignedT = false;
            this.errorNotYoursT = false;
            this.allNotes[i].Completed = true;
            this.allNotes[i].DueDate = this.allNotes[i].DueDate.toJSON();
            this.saveTaskNote(this.allNotes[i]);
          } else if (
            this.allNotes[i].Assignee ==
            this.helpersService.getProfileData().Name +
              ' ' +
              this.helpersService.getProfileData().Surname
          ) {
            this.errorNotUnassignedT = false;
            this.errorNotYoursT = false;
            this.allNotes[i].Completed = true;
            this.allNotes[i].DueDate = this.allNotes[i].DueDate.toJSON();
            this.saveTaskNote(this.allNotes[i]);
          } else if (this.allNotes[i].Assignee == 'Not Assigned') {
            this.errorNotUnassignedT = true;
          } else if (
            this.allNotes[i].Assignee !=
            this.helpersService.getProfileData().Name +
              ' ' +
              this.helpersService.getProfileData().Surname
          ) {
            this.errorNotYoursT = true;
          }
        } else {
          if (
            this.allNotes[i].Assignee != 'Not Assigned' &&
            this.allNotes[i].Assignee ==
              this.helpersService.getProfileData().Name +
                ' ' +
                this.helpersService.getProfileData().Surname
          ) {
            this.errorNotUnassigned = false;
            this.errorNotYours = false;
            this.allNotes[i].Completed = true;
            this.allNotes[i].DueDate = this.allNotes[i].DueDate.toJSON();
            this.saveTaskNote(this.allNotes[i]);
          } else if (
            this.allNotes[i].Assignee ==
            this.helpersService.getProfileData().Name +
              ' ' +
              this.helpersService.getProfileData().Surname
          ) {
            this.errorNotUnassigned = false;
            this.errorNotYours = false;
            this.allNotes[i].Completed = true;
            this.allNotes[i].DueDate = this.allNotes[i].DueDate.toJSON();
            this.saveTaskNote(this.allNotes[i]);
          } else if (this.allNotes[i].Assignee == 'Not Assigned') {
            this.errorNotUnassigned = true;
          } else if (
            this.allNotes[i].Assignee !=
            this.helpersService.getProfileData().Name +
              ' ' +
              this.helpersService.getProfileData().Surname
          ) {
            this.errorNotYours = true;
          }
        }
      }
    }
  }

  setTaskEmployee(id, event) {
    this.allNotes[id].AssigneeID = event.value.ID;
    this.allNotes[id].AssigneeName = event.value.Name;
    this.saveTaskNote(this.allNotes[id]);
  }

  setTaskDueDate(id, event) {
    var month = this.allNotes[id].DueDate.getUTCMonth() + 1; //months from 1-12
    var day = this.allNotes[id].DueDate.getUTCDate();
    var year = this.allNotes[id].DueDate.getUTCFullYear();

    this.allNotes[id].DueDate = moment
      .utc(this.allNotes[id].DueDate.toString())
      .format('L');

    this.saveTaskNote(this.allNotes[id]);
    this.dueDate = null;
  }

  //====================================================================================
  //QUOTES
  //====================================================================================
  sendMessage() {
    var bikeID = 0;
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name == this.bikeSelected)
        bikeID = this.claimObject.Bikes[i].ID;
    }

    this.messages.push({
      Message: this.message,
      CreatedDate: new Date(),
      To: this.selectedPartner.label,
      Direction: 'Outgoing',
      Type: 'SMS',
    });

    this.quoteObject.ClaimID = this.claimObject.ID;
    this.quoteObject.BikeID = bikeID;
    if (this.selectedPartner.value !== undefined)
      this.quoteObject.PartnerID = this.selectedPartner.value.ID;
    else this.quoteObject.PartnerID = this.selectedPartner.ID;

    this.quoteObject.Message = this.message;

    this.insuranceService
      .saveQuote(JSON.stringify(this.quoteObject))
      .subscribe((response) => {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Quotes.length; i++) {
          this.quoteObject = obj.Quotes[i];
        }
      });

    this.message = '';
  }

  onBikeChange() {
    this.getMessages();
    this.getQuote();
  }

  getMessages() {
    if (this.selectedPartner !== undefined) {
      var bikeID = 0;
      for (var i = 0; i < this.claimObject.Bikes.length; i++) {
        if (this.claimObject.Bikes[i].Name == this.bikeSelected)
          bikeID = this.claimObject.Bikes[i].ID;
      }
      var pID = 0;

      if (this.selectedPartner.value !== undefined)
        pID = this.selectedPartner.value.ID;
      else pID = this.selectedPartner.ID;

      this.insuranceService
        .getQuoteMessages(pID, bikeID)
        .subscribe((response) => {
          if (response != '') {
            this.messages = [];
            var obj = JSON.parse(response);
            for (var i = 0; i < obj.Messages.length; i++) {
              this.messages.push(obj.Messages[i]);
              pID = obj.Messages[i].PartnerID;
            }
          }
        });
    }
  }

  getQuote() {
    var bikeID = 0;
    for (var i = 0; i < this.claimObject.Bikes.length; i++) {
      if (this.claimObject.Bikes[i].Name == this.bikeSelected)
        bikeID = this.claimObject.Bikes[i].ID;
    }
    var pID = 0;
    pID = this.helpersService.getPartnerId();

    if (this.selectedPartner.value !== undefined)
      pID = this.selectedPartner.value.ID;
    else pID = this.selectedPartner.ID;

    this.subtotal = 0;
    this.tax = 0;
    this.total = 0;
    this.lineItems = [];

    this.insuranceService
      .getClaimQuotesFromPartners(pID, bikeID)
      .subscribe((response) => {
        if (response != '') {
          var obj = JSON.parse(response);
          for (var i = 0; i < obj.LineItems.length; i++) {
            this.lineItems.push(obj.LineItems[i]);
          }

          for (var i = 0; i < obj.LineItems.length; i++) {
            this.subtotal +=
              obj.LineItems[i].UnitPrice * obj.LineItems[i].Quantity;
            this.tax +=
              (obj.LineItems[i].UnitPrice_IncludingTax -
                obj.LineItems[i].UnitPrice) *
              obj.LineItems[i].Quantity;
            this.total +=
              obj.LineItems[i].UnitPrice_IncludingTax *
              obj.LineItems[i].Quantity;
          }
        }
      });
  }

  //====================================================================================
  //MESSAGING
  //====================================================================================

  updateScroll() {
    var element = document.getElementById('notification-container');
    element.scrollTop = element.scrollHeight;
  }

  sendMessages() {
    this.sendingM = true;
    this.insuranceService
      .sendMessage({
        message: this.messageM,
        number: this.claimObject.InsuredPhone,
        claimID: this.claimObject.ID,
      })
      .subscribe((response) => {
        var obj = JSON.parse(response);
        for (var i = 0; i < obj.Claims.length; i++) {
          this.claimObject = obj.Claims[i];
          this.sendingM = false;
        }
      });
    this.messageM = '';
  }

  addTamplateMessage(type) {
    if (type == 'CompleteClaim') {
      var url = this.insuranceService
        .getShortenedURL(this.claimObject.ID)
        .subscribe((xyz) => {
          this.messageM =
            'Hi ' +
            this.claimObject.InsuredName +
            '. We started to review your bicycle claim. Please click on the link, ' +
            xyz +
            ', and complete the form. Riders at Work';
        });
    }
  }

  //====================================================================================
  //ATTACHMENTS
  //====================================================================================
  loadImages() {
    this.images = [];
    for (var i = 0; i < this.claimObject.Attachments.length; i++) {
      if (this.claimObject.Attachments[i].FileType !== undefined)
        if (this.claimObject.Attachments[i].FileType.startsWith('image')) {
          this.images.push(this.claimObject.Attachments[i]);
        }
    }
  }

  loadDocuments() {
    this.documents = [];
    for (var i = 0; i < this.claimObject.Attachments.length; i++) {
      if (this.claimObject.Attachments[i].FileType !== undefined)
        if (!this.claimObject.Attachments[i].FileType.startsWith('image'))
          this.documents.push({
            source: this.claimObject.Attachments[i].FileURL,
            title: this.claimObject.Attachments[i].FileName,
          });
    }
  }

  onUpload(event, fileUpload) {
    var count = 0;
    var arrC = 0;

    this.uploadedFiles = [];
    var cont = true;
    for (let file of event.files) {
      if (this.uploadedFiles.indexOf(file) === -1)
        this.uploadedFiles.push(file);
    }

    for (var i = 0; i < this.uploadedFiles.length; i++) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[i]);
      reader.onload = (file: any) => {
        let data = {
          ID: 0,
          ClaimID: 0,
          FileType: this.uploadedFiles[arrC].type,
          FileName: this.uploadedFiles[arrC].name,
          FileURL: '',
          FileData: file.target.result.split(',')[1],
        };

        if (this.claimObject.Attachments.indexOf(data) === -1)
          this.claimObject.Attachments.push(data);

        count += 1;
        arrC += 1;

        if (count == this.uploadedFiles.length) {
          this.insuranceService
            .saveClaim(this.claimObject)
            .subscribe((response) => {
              this.images = [];
              this.setClaimObj(response);
              this.loadImages();
              this.loadDocuments();
              fileUpload.clear();
            });
        }
      };
    }
  }

  onRemove(event) {
    this.uploadedFiles.splice(this.uploadedFiles.indexOf(event.file), 1);
  }

  onDoUpload(event) {}
}
